// extracted by mini-css-extract-plugin
module.exports = {"info-row":"InfoRow_info-row__1bmua","as-column":"InfoRow_as-column__2pD3i"};